import DuplicateClientAllocation from './DuplicateClientAllocation';

export default DuplicateClientAllocation;
